























































import {Vue, Component, Prop} from 'vue-property-decorator';
import {
	ServiceInvoice,
	ServiceRecordDTO,
	UpdateInvoicePayload
} from "@/components/payroll/business/services/ServiceDTO";
import moment from "moment/moment";
import Application from "@/state/Application";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import {processError} from "@/utils/ComponentUtils";
import {prettyEnum} from "@/utils/StringUtils";
import ServiceLogUpdateSlider from "@/components/payroll/business/services/service/ServiceLogUpdateSlider.vue";
import ServiceLogViewSlider from "@/components/payroll/business/services/service/ServiceLogViewSlider.vue";
import RouteNames from "@/router/RouteNames";

export type ServiceInvoiceSide = 'PAYER' | 'PAYEE'

@Component({
	components: {ServiceLogViewSlider, ServiceLogUpdateSlider},
	methods: {
		RouteNames() {
			return RouteNames
		},
		prettyEnum(val: string) {
			return prettyEnum(val)
		}
	},
	computed: {
		moment() {
			return moment
		}
	}
})
export default class ServiceInvoiceItem extends Vue {

	private open = false;
	private updateLog = false
	private viewLog = false;

	private selectedLog: ServiceRecordDTO | null = null

	@Prop()
	private invoice!: ServiceInvoice

	private req = new UpdateInvoicePayload(
		{
			serviceInvoiceId: this.invoice.id,
			payerId: this.$wss.getCurrent.id
		}
	)

	@Prop({default: 'PAYER'})
	private side!: ServiceInvoiceSide

	private formatDate(date: Date | string): string {
		return moment(date).format("MM.DD.YYYY");
	}

	private resolveStatusColor(inv: ServiceInvoice) {
		switch (inv.status) {
			case "DRAFT": return "#818181"
			case "IN_PROGRESS": return "#007bff"
			case "PAID": return "#28a745"
			case "VOIDED": return "#dc3545"
		}
	}

	private voidInvoice() {
		Application.startLoading()
		this.req.status = 'VOIDED'
		ServiceInvoiceOrchestrator.changeStatus(this.req).then(
			() => {
				this.$emit('void', this.invoice)
			},
			err => processError(err, this)
		).finally(() => Application.stopLoading())
	}

	private resolveInvoiceTitle(invoice: ServiceInvoice) {
		if (invoice.payer.userId == this.$wss.getCurrent.userId) {
			return invoice.payee.name
		} else {
			return invoice.payer.name
		}
	}

	private completeInvoice() {
		Application.startLoading()
		this.req.status = 'PAID'
		ServiceInvoiceOrchestrator.changeStatus(this.req).then(
			() => {
				this.$emit('paid', this.invoice)
			},
			err => processError(err, this)
		).finally(() => Application.stopLoading())
	}

	private openLog(log: ServiceRecordDTO) {
		this.selectedLog = log
		if (log.executor.userId == this.$wss.getCurrent.userId) {
			this.updateLog = true;
		} else {
			this.viewLog = true;
		}
	}
}
